import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import I18n from 'i18n-react';
import './LoginCallcenter.css';

const ENTER_KEYEVENT = 'enter';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  showLoginCallcenterLoading: PropTypes.bool
};

const defaultProps = {
  showLoginCallcenterLoading: false
};

class LoginCallcenter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoginCallcenterFilled: true,
      isButtonDisabled: true,
      loginCallcenter: ''
    };

    this.handleFormKeyUp = this.handleFormKeyUp.bind(this);
  }

  renderLoginCallcenter() {
    return (
      <div className="LoginCallcenter__container">
        <Row>
          <Col className="LoginCallcenter__loginLabel">
            <span
              className={
                this.state.isLoginCallcenterFilled ? 'Field__validField' : 'Field__invalidField'
              }>
              {I18n.translate('components.loginCallcenter.loginCallcenterLabel')}
            </span>
            <span className="LoginCallcenter__required">*</span>
          </Col>
        </Row>
        <Row>
          <Col className="LoginCallcenter__input">
            <input
              type="text"
              id={`${this.props.id}_loginField`}
              onChange={this.handleLoginCallcenterChange}
              onBlur={this.validateLoginCallcenter}
              placeholder={I18n.translate('components.loginCallcenter.loginCallcenterPlaceholder')}
              className={`Field__input ${
                this.state.isLoginCallcenterFilled ? 'Field__validInput' : 'Field__invalidInput'
              }`}
              value={this.state.loginCallcenter}
              maxLength={18}
            />
          </Col>
        </Row>
        {this.renderValidationMessage(
          this.state.isLoginCallcenterFilled,
          'components.loginCallcenter.cpfErrorMessage'
        )}
      </div>
    );
  }

  renderValidationMessage(isFieldFilled, message) {
    let footer = <Row id="LoginCallcenter__errorMessageFooter" className="Field__message" />;

    if (!isFieldFilled) {
      footer = (
        <Row className="Field__message error">
          <Col id="LoginCallcenter__errorMessage">
            <span> {I18n.translate(message)} </span>
          </Col>
        </Row>
      );
    }

    return footer;
  }

  handleFormKeyUp(event) {
    if (event.key.toLowerCase() === ENTER_KEYEVENT) {
      this.validate(event);
    }
  }

  validate = event => {
    event.preventDefault();
    let isLoginCallcenterValid = this.validateLoginCallcenter();
    let isValid = isLoginCallcenterValid && this.props.termIsChecked;
    if (isValid) {
      this.props.changeValue(this.state.loginCallcenter);
    }else {
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    return isValid;
  };

  handleLoginCallcenterChange = event => {
    let isButtonDisabled = true;
    if(!this.props.termIsChecked){
      this.props.setCheckboxBorderNameCallback('invalidField');
    }
    if (event.target.value) {
      isButtonDisabled = false;
    }
    this.setState({
      loginCallcenter: event.target.value,
      isButtonDisabled: isButtonDisabled
    });
  };

  validateLoginCallcenter = () => {
    let isValidState = this.state.loginCallcenter.length > 0;

    this.setState({
      isLoginCallcenterFilled: isValidState
    });

    return isValidState;
  };

  setDisabledButton(){
    if (this.props.termIsChecked && !this.state.isButtonDisabled){
      return false ;
    }
    return true ;
  }

  render() {
    let loginWrapperClass =
      'Login__backgroundMobile ' +
      (this.props.showLoginCallcenterLoading ? 'Login__withLoading' : '');
    return (
      <form id={this.props.id} onSubmit={this.validate} onKeyUp={this.handleFormKeyUp}>
        <hr />
        <Row className={loginWrapperClass}>
          <Row className="LoginCallcenter__label">
            <Col md={5} className="LoginCallcenter__titleContainer">
              <label className="LoginCallcenter__title">
                {I18n.translate('components.loginCallcenter.identifyclient')}
              </label>
            </Col>
            <div className="LoginCallcenter__backgroud">
              <Col md={6} className="LoginCallcenter__background">
                <Row className="LoginCallcenter__rowInput">
                  <Col md={5} className="LoginCallcenter__inputLogin">
                    {this.renderLoginCallcenter()}
                  </Col>
                  <Col md={7} className="LoginCallcenter__textCenter">
                    <Button
                      id="btnLogin"
                      type="submit"
                      className="btnOkLoginCallcenter"
                      disabled={this.setDisabledButton()}>
                      {I18n.translate('components.loginCallcenter.buttonOk')}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </div>
          </Row>
        </Row>
        <hr />
      </form>
    );
  }
}

LoginCallcenter.propTypes = propTypes;
LoginCallcenter.defaultProps = defaultProps;

export default LoginCallcenter;



// WEBPACK FOOTER //
// ./src/components/loginCallcenter/LoginCallcenter.jsx